module.exports = __webpack_public_path__ + "static/mypic-01be14495451437fc2eb712eaf2967ae.jpg";